import Controller from "./fileDownload.controller";
import template from "./fileDownload.html";

const fileDownload = {
  template,
  controller: Controller,
};

export default fileDownload;



// WEBPACK FOOTER //
// ./src/pages/fileDownload/fileDownload.component.js